import React from 'react';

const SvgCheckedOut: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M4 18.593V17.4819H5.48154V7.33909C5.48154 6.9649 5.61118 6.64817 5.87045 6.3889C6.12972 6.12963 6.44645 6 6.82064 6H13.7724C14.1466 6 14.4634 6.12963 14.7226 6.3889C14.9819 6.64817 15.1115 6.9649 15.1115 7.33909V17.4819H16.5931V18.593H4ZM14.0004 17.4819V7.33909C14.0004 7.2821 13.9767 7.22985 13.9292 7.18236C13.8817 7.13488 13.8294 7.11113 13.7724 7.11113H6.82064C6.76365 7.11113 6.7114 7.13488 6.66391 7.18236C6.61642 7.22985 6.59268 7.2821 6.59268 7.33909V17.4819H14.0004Z" // eslint-disable-line max-len
      fill="#99A3AC"
    />
    <path
      d="M17.8603 12.2869H10.6051V11.1757H17.8603L16.5127 9.8281L17.2933 9.02466L20 11.7313L17.2933 14.4379L16.5127 13.6345L17.8603 12.2869Z"
      fill="#99A3AC"
    />
  </svg>
);

export default SvgCheckedOut;
